/* eslint-disable react/react-in-jsx-scope */
import React from 'react'

export const get_timeline = (type) => {
	if (type === 'event') return custom_crafted_timeline
	if (type === 'event_567') return performed_based_timeline
	if (type === 'appointment') return appointments_timeline

	return { main: [], conditional: [] }
}

const custom_crafted_timeline = {
	main: [
		{ type: 'header', events: [{ title: 'Attendee Registration' }] },
		{
			type: 'multi_action',
			descriptions: ['Immediately Upon Registration'],
			events: [
				{
					id: 'event_registration',
					title: 'Event Registration',
					template_index: 2,
					email_name: 'EVENT_REGISTRATION',
					email_description: 'Deploys immediately upon registration. Contains full Event details.',
				},
				{
					id: 'event_waitlist',
					title: 'Event Waitlist',
					template_index: 3,
					email_name: 'EVENT_WAITLIST',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon registration if Event is beyond maximum capacity.</li>
							<li>
								“Waitlisted” registrants do not receive additional communications unless moved into the
								“Registered” list.
							</li>

							<li>Potential workflow if an opening occurs:</li>
							<ul style={{ paddingLeft: '20px' }}>
								<li>Call the Waitlisted registrants to obtain their commitment for the Event.</li>
								<li>
									If registrant confirms, use the{' '}
									<a
										href="http://help.leadjig.com/en/articles/4603524-how-to-move-attendees-off-waitlist-or-into-another-event"
										target="_blank"
									>
										"Move"
									</a>{' '}
									button to shift the Attendee Record into the "Registered" list.
								</li>
								<li>
									Assign the{' '}
									<a
										href="http://help.leadjig.com/en/articles/3198730-how-to-confirm-prospects-for-events"
										target="_blank"
									>
										"Confirmation Status"
									</a>{' '}
									using the ✔ icon.
								</li>
								<li>
									The registrant will receive any remaining Event communications as they progress
									through the timeline.
								</li>
							</ul>
						</ul>
					),
				},
			],
		},
		{
			type: 'call',
			events: [
				{
					id: 'outbound_call_1',
					title: 'Outbound Call',
					description: (
						<React.Fragment>
							<p className="mb-1">Potential Workflow to maximize results:</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>
									Call each registrant and{' '}
									<a
										href="http://help.leadjig.com/en/articles/3198730-how-to-confirm-prospects-for-events"
										target="_blank"
									>
										confirm attendance
									</a>{' '}
									. If you prefer AcquireUp calls on your behalf, please inquire with your Marketing
									Consultant.
								</li>
								<ul style={{ paddingLeft: '20px' }}>
									<li>
										If successfully confirmed: assign the "Confirmation Status" using the ✔ icon on
										the corresponding Attendee Record within the Event.
									</li>
									<li>
										If confirmation remains pending: do not assign a "Confirmation Status." Leave a
										voicemail and place notes on the Attendee Record within the Event.
									</li>
								</ul>
							</ul>
						</React.Fragment>
					),
				},
			],
		},
		{
			type: 'action',
			descriptions: ['Day Before Event - 9:00 AM'],
			events: [
				{
					id: 'event_confirmation',
					title: 'Event Confirmation',
					template_index: 5,
					email_name: 'EVENT_CONFIRMATION',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys one day before the Event at 9:00 AM local time.</li>
							<li>Sends to registrants that are still pending a "Confirmation Status."</li>
							<li>The registrant can self-confirm using a button built into this email.</li>
						</ul>
					),
					sms_name: 'TEMPLATE_EVENT_CONFIRMATION',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys one day before the Event at 9:00 AM local time.</li>
							<li>Sends to registrants that are still pending a "Confirmation Status."</li>
							<li>The registrant may reply "Y" or "YES" to self-confirm.</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'action',
			descriptions: ['Morning of Event - 9:00 AM'],
			events: [
				{
					id: 'event_reminder',
					title: 'Event Reminder',
					sms_name: 'TEMPLATE_EVENT_REMINDER',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys morning of the Event at 9:00 AM local time.</li>
							<li>Sends to everyone within the "Registered" list (regardless of Confirmation Status).</li>
							<li>
								If this message is received by a smartphone, the venue address appears as a hyperlink
								that opens a map with directions.
							</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'header',
			events: [{ title: 'Event Date' }],
		},
		{
			type: 'action',
			descriptions: ['Within 1 Week of Event Ending'],
			events: [
				{
					id: 'event_thank_you',
					title: 'Event Thank You',
					template_index: 6,
					email_name: 'EVENT_THANK_YOU',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Event.
							</li>
						</ul>
					),
				},
				{
					id: 'event_no_show',
					title: 'Event No Show',
					template_index: 7,
					email_name: 'EVENT_NO_SHOW',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Event.
							</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'call',
			events: [
				{
					id: 'outbound_call_2',
					title: 'Outbound Call',
					description: (
						<React.Fragment>
							<p className="mb-1">Potential Workflow to maximize results:</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>Call to thank attendees for coming to the Event.</li>
								<ul style={{ paddingLeft: '20px' }}>
									<li>
										If attendee already scheduled an Appointment, confirm the time still works and
										arrange any final details for the meeting.
									</li>
									<li>
										If attendee did not schedule an Appointment yet, extend an offer to meet one-
										on-one.
									</li>
								</ul>
								<li>
									Call no-shows to offer package of information. Offer one-on-one Appointment to
									discuss materials covered at the Event.
								</li>
							</ul>
						</React.Fragment>
					),
				},
			],
		},
	],
	conditional: [
		{ type: 'header', is_conditional: true },
		{
			events: [
				{
					id: 'event_invitation',
					title: 'Event Invitation',
					email_name: 'EVENT_INVITATION',
					email_description: (
						<React.Fragment>
							<p className="mb-1">{`* Only deploys if the "Social Share" setting is activated (found under Preferences -> Landing Page -> Options)`}</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>
									After registering on a Landing Page, the registrant can use buttons that share the
									Event with friends through Facebook, X (formerly Twitter), LinkedIn, or via email.
								</li>
								<li>
									If someone registers through Social Share, the tracking attribution on their
									attendee record will show the name of the referrer.
								</li>
							</ul>
						</React.Fragment>
					),
					template_index: 4,
				},
			],
		},
		{
			events: [
				{
					id: 'event_reschedule',
					title: 'Event Reschedule',
					email_name: 'EVENT_RESCHEDULE',
					email_description: (
						<p>
							* Only deploys if an Event is formally Rescheduled through the "Manage Event" tool. It is
							located within the Event menu when viewing the Attendee list.
						</p>
					),
					template_index: 19,
				},
			],
		},
		{
			events: [
				{
					id: 'event_postpone',
					title: 'Event Postpone',
					email_name: 'EVENT_POSTPONE',
					email_description: (
						<p>
							* Only deploys if an Event is formally Postponed through the "Manage Event" tool. It is
							located within the Event menu when viewing the Attendee list.
						</p>
					),
					template_index: 20,
				},
			],
		},
		{
			events: [
				{
					id: 'event_promote',
					title: 'Event Promote',
					email_name: 'EVENT_PROMOTE',
					email_description: (
						<p>
							* AcquireUp representatives can deploy this message on your behalf. If there is a need to
							fill additional seats, please ask your AcquireUp Marketing Consultant for best practices.
						</p>
					),
					template_index: 21,
				},
			],
		},
		{
			events: [
				{
					id: 'event_cancelation',
					title: 'Event Cancelation',
					email_name: 'EVENT_CANCELATION',
					email_description: (
						<p>* Only deploys if AcquireUp is asked to formally Cancel the entire Event on your behalf.</p>
					),
					sms_name: 'TEMPLATE_EVENT_CANCELATION',
					sms_description: (
						<p>* Only deploys if AcquireUp is asked to formally Cancel the entire Event on your behalf.</p>
					),
					template_index: 13,
				},
			],
		},
		{
			events: [
				{
					id: 'digital_registration_confirmation',
					title: 'Digital Registration Confirmation',
					template_index: 17,
					email_name: 'DIGITAL_REGISTRATION_CONFIRMATION',
					email_description: (
						<React.Fragment>
							<p>
								{'* Only deploys if the '}
								<a
									href="http://help.leadjig.com/en/articles/9797309-how-to-setup-digital-registration-confirmation"
									target="_blank"
								>
									"Confirm Digital Registrations"
								</a>
								{' setting is activated (found under Preferences -> Landing Page -> Registration).'}
							</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>
									Serves as a double Opt-In for registrants coming through “Digital” tracking Lures.
								</li>

								<li>Deploys immediately upon registration.</li>

								<li>
									States that their registration is not yet finalized. They will receive the “Digital
									Confirmation SMS” and “Digital Registration Confirmation Email” 24 hours after the
									initial registration. The registrant must respond back to one of these messages to
									secure their seat for the event.
								</li>
							</ul>
						</React.Fragment>
					),
				},
			],
		},
		{
			events: [
				{
					id: 'digital_alert',
					title: 'Digital Alert',
					sms_name: 'TEMPLATE_DIGITAL_ALERT',
					sms_description: (
						<React.Fragment>
							<p>
								{'* Only deploys if the '}
								<a
									href="http://help.leadjig.com/en/articles/9797309-how-to-setup-digital-registration-confirmation"
									target="_blank"
								>
									"Confirm Digital Registrations"
								</a>
								{' setting is activated (found under Preferences -> Landing Page -> Registration).'}
							</p>
						</React.Fragment>
					),
				},
			],
		},
		{
			events: [
				{
					id: 'digital_confirmation',
					title: 'Digital Confirmation',
					sms_name: 'TEMPLATE_DIGITAL_CONFIRMATION',
					sms_description: (
						<React.Fragment>
							<p>
								{'* Only deploys if the '}
								<a
									href="http://help.leadjig.com/en/articles/9797309-how-to-setup-digital-registration-confirmation"
									target="_blank"
								>
									"Confirm Digital Registrations"
								</a>
								{' setting is activated (found under Preferences -> Landing Page -> Registration).'}
							</p>
						</React.Fragment>
					),
				},
			],
		},
		{
			events: [
				{
					id: 'communication_sms',
					title: 'Communication Opt-In',
					sms_name: 'TEMPLATE_COMMUNICATION_OPT_IN',
				},
			],
		},
	],
}

const performed_based_timeline = {
	main: [
		{ type: 'header', events: [{ title: 'Attendee Registration' }] },
		{
			type: 'multi_action',
			descriptions: ['Immediately Upon Registration '],
			events: [
				{
					id: 'event_registration',
					title: 'Event Registration',
					email_name: 'EVENT_REGISTRATION',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon Registration.</li>
							<li>Contains full Event details.</li>
							<li>Includes a map with driving directions to the Venue.</li>
						</ul>
					),
					sms_name: 'TEMPLATE_EVENT_REGISTRATION',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon Registration.</li>
							<li>Contains full Event details.</li>
						</ul>
					),
					template_index: 2,
				},
				{
					id: 'event_waitlist',
					title: 'Event Waitlist',
					template_index: 3,
					email_name: 'EVENT_WAITLIST',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon registration if Event is beyond maximum capacity.</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'action',
			descriptions: ['6 Days Before Event - 9:00 AM'],
			events: [
				{
					id: 'event_reminder',
					title: 'Event Reminder',
					email_name: 'EVENT_REMINDER',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 6 days before the event at 9:00 AM local time.</li>
							<li>Contains full Event details.</li>
							<li>Includes a Map with driving directions to the Venue.</li>
						</ul>
					),
					template_index: 18,
				},
			],
		},
		{
			type: 'action',
			descriptions: ['2 Days Before Event - 9:00 AM'],
			events: [
				{
					id: 'event_confirmation',
					title: 'Event Reminder 2',
					email_name: 'EVENT_CONFIRMATION',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 2 days before the event at 9:00 AM local time.</li>
							<li>Contains full Event details.</li>
							<li>Includes a Map with driving directions to the Venue.</li>
						</ul>
					),
					template_index: 5,
				},
			],
		},
		{
			type: 'action',
			descriptions: ['Morning of Event - 9:00 AM'],
			events: [
				{
					id: 'event_reminder_sms',
					title: 'Event Reminder SMS',
					sms_name: 'TEMPLATE_EVENT_REMINDER',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys morning of the Event at 9:00 AM local time.</li>
							<li>Contains full Event details.</li>
						</ul>
					),
					template_index: 18,
				},
			],
		},
		{
			type: 'call',
			events: [
				{
					id: 'confirmation_call',
					title: 'Outbound Call',
					description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>AcquireUp calls each Registrant to confirm.</li>
							<li>This call is made 1 day before the Event.</li>
							<ul style={{ paddingLeft: '30px' }}>
								<li>If unable to confirm, a second call is placed the morning of the Event.</li>
							</ul>
						</ul>
					),
				},
			],
		},
		{
			type: 'header',
			events: [{ title: 'Event Date' }],
		},
		{
			type: 'action',
			descriptions: ['Within 1 Week of Event Ending'],
			events: [
				{
					id: 'event_thank_you',
					title: 'Event Thank You',
					template_index: 6,
					email_name: 'EVENT_THANK_YOU',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Event.
							</li>
						</ul>
					),
				},
				{
					id: 'event_no_show',
					title: 'Event No Show',
					template_index: 7,
					email_name: 'EVENT_NO_SHOW',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Event.
							</li>
						</ul>
					),
				},
			],
		},
	],
	conditional: [
		{ type: 'header', is_conditional: true },
		{
			events: [
				{
					id: 'event_invitation',
					title: 'Event Invitation',
					email_name: 'EVENT_INVITATION',
					email_description: (
						<React.Fragment>
							<p>{`* Only Deploys if the "Social Share" setting is activated (found under Preferences -> Landing Page -> Options)`}</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>Call and thank attendees for coming to the Event.</li>
								<ul style={{ paddingLeft: '30px' }}>
									<li>
										After completing the Registration form on a Landing Page, the registrant can
										share the Event with friends through Facebook, X (formerly Twitter), LinkedIn,
										or via Email.
									</li>
									<li>
										If someone Registers through Social Share, the tracking attribution on their
										Attendee Record will show the name of the referrer.
									</li>
								</ul>
								<li>Call no shows to offer package of information. Offer Appointment times.</li>
							</ul>
						</React.Fragment>
					),
					template_index: 4,
				},
			],
		},
		{
			events: [
				{
					id: 'event_reschedule',
					title: 'Event Reschedule',
					email_name: 'EVENT_RESCHEDULE',
					email_description: (
						<p>
							* Only deploys if an Event is formally Rescheduled through the "Manage Event" tool. It is
							located within the Event menu when viewing the Attendee list.
						</p>
					),
					template_index: 19,
				},
			],
		},
		{
			events: [
				{
					id: 'event_postpone',
					title: 'Event Postpone',
					email_name: 'EVENT_POSTPONE',
					email_description: (
						<p>
							* Only deploys if an Event is formally Postponed through the "Manage Event" tool. It is
							located within the Event menu when viewing the Attendee list.
						</p>
					),
					template_index: 20,
				},
			],
		},
		{
			events: [
				{
					id: 'event_cancelation',
					title: 'Event Cancelation',
					email_name: 'EVENT_CANCELATION',
					email_description: (
						<p>* Only deploys if AcquireUp is asked to formally Cancel the entire Event on your behalf.</p>
					),
					sms_name: 'TEMPLATE_EVENT_CANCELATION',
					template_index: 13,
				},
			],
		},
	],
}

const appointments_timeline = {
	main: [
		{ type: 'header', events: [{ title: 'Contact Registration' }] },
		{
			type: 'action',
			descriptions: ['Immediately Upon Registration'],
			events: [
				{
					id: 'appointment_registration',
					title: 'Appointment Registration',
					email_name: 'APPOINTMENT_REGISTRATION',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon Registration.</li>
							<li>Contains the requested Appointment time.</li>
							<li>
								States they will be contacted back to confirm their Appointment and arrange for a way to
								meet.
							</li>
						</ul>
					),
					template_index: 8,
				},
			],
		},
		{
			type: 'call',
			events: [
				{
					id: 'confirmation_call',
					title: 'Outbound Call',
					description: (
						<React.Fragment>
							<p className="mb-1">Potential Workflow to maximize results:</p>

							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>Call attendee to confirm the appointment.</li>
								<ul style={{ paddingLeft: '20px' }}>
									<li>
										If successfully confirmed: assign the "Confirmation Status" for the Appointment
										using the √ icon within the corresponding Contact record.
									</li>
									<li>
										If confirmation remains pending: do not assign a "Confirmation Status." Leave a
										voicemail and place notes on the Appointment or Contact record.
									</li>
								</ul>
							</ul>
						</React.Fragment>
					),
				},
			],
		},
		{
			type: 'action',
			descriptions: ['2 Days Before Appointment - 9:00 AM'],
			events: [
				{
					id: 'appointment_confirmation',
					title: 'Appointment Confirmation',
					sms_name: 'TEMPLATE_APPOINTMENT_CONFIRMATION',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 2 day before Appointment at 9:00 AM local time.</li>
							<li>Asks the prospect to reply back Y or YES to confirm.</li>
							<li>
								If confirmed, the "Confirmation Status" associated with their Appointment lights up
								green.
							</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'action',
			descriptions: ['1 Day Before Appointment - 9:00 AM'],
			events: [
				{
					id: 'appointment_reminder',
					title: 'Appointment Reminder',
					sms_name: 'TEMPLATE_APPOINTMENT_REMINDER',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys day-of the Appointment at 9:00 AM local time.</li>
							<li>Contains Appointment date and time.</li>
						</ul>
					),
				},
			],
		},
		{
			type: 'header',
			events: [{ title: 'Appointment Date' }],
		},
		{
			type: 'action',
			descriptions: ['Within 1 Week of Appointment Date'],
			events: [
				{
					id: 'appointment_thank_you',
					title: 'Appointment Thank You',
					email_name: 'APPOINTMENT_THANK_YOU',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Appointment.
							</li>
						</ul>
					),
					template_index: 9,
				},
				{
					id: 'appointment_no_show',
					title: 'Appointment No Show',
					template_index: 10,
					email_name: 'APPOINTMENT_NO_SHOW',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys 4:00 PM local time the day an "Attended Status" is assigned.</li>
							<li>
								If "Attended Status" is assigned after 4:00 PM, the email deploys 4:00 PM the following
								day.
							</li>
							<li>
								Note: this email only deploys if the "Attended Status" is assigned within 7 days of the
								Appointment.
							</li>
						</ul>
					),
				},
			],
		},
	],
	conditional: [
		{ type: 'header', is_conditional: true },
		{
			events: [
				{
					id: 'appointment_cancelation',
					title: 'Appointment Cancelation',
					sms_name: 'TEMPLATE_APPOINTMENT_CANCELATION',
					sms_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon canceling an Appointment.</li>
							<li>States they will be contacted if alternate times are available.</li>
						</ul>
					),
				},
			],
		},
		{
			events: [
				{
					id: 'contact_follow_up',
					title: 'Contact Follow Up',
					email_name: 'CONTACT_FOLLOW_UP',
					email_description: (
						<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
							<li>Deploys immediately upon registration if no Event date is selected.</li>
							<li>Common scenarios include:</li>
							<ul style={{ paddingLeft: '15px', marginBottom: '10px' }}>
								<li>
									All the Event dates have passed. The registrant submits their Contact information
									with a note.
								</li>
								<li>Requests to be removed from mailing list.</li>
								<li>Questions about meal choices (for meal events).</li>
							</ul>
							<li>
								Also deploys if the Campaign does not promote Event dates, typically with the Objective
								of Lead Generation, File Download, or Webinar.
							</li>
						</ul>
					),
					template_index: 11,
				},
			],
		},
	],
}

export const template_indexes = {
	'-4': 'custom_follow_up',
	'-3': 'custom_appointment',
	'-2': 'custom_event',
	'-1': 'custom',
	1: 'notification',
	2: 'event_registration',
	3: 'event_waitlist',
	4: 'event_invitation',
	5: 'event_confirmation',
	6: 'event_thank_you',
	7: 'event_no_show',
	8: 'appointment_registration',
	9: 'appointment_thank_you',
	10: 'appointment_no_show',
	11: 'contact_follow_up',
	12: 'payment_request',
	13: 'event_cancelation',
	14: 'appointment_confirmation',
	15: 'appointment_reschedule',
	16: 'second_appointment',
	17: 'digital_registration_confirmation',
	18: 'event_reminder',
	19: 'event_reschedule',
	20: 'event_postpone',
	21: 'event_promote',
}
